import { configureStore } from '@reduxjs/toolkit';

import { crewSlice } from './API/crewSlice';
import { categorySlice } from './API/categorySlice';
import { emailSlice } from './API/email';
import { ambassadorSlice } from './API/ambassadorSlice';
import { lossesSlice } from './API/lossesSlice';
import { promoVideoSlice } from './API/promoVideoSlice';
import { detailsSlice } from './API/detailsSlice';

import isAuthReducer from './isAuthSlice';
import langReducer from './langSlice';

import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const isAuthConfig = {
  key: 'isAuth',
  version: 1,
  storage
};

const langConfig = {
  key: 'lang',
  version: 1,
  storage
};

const persistedIsAuthReducer = persistReducer(isAuthConfig, isAuthReducer);
const persistedLangReducer = persistReducer(langConfig, langReducer);

export const store = configureStore({
  reducer: {
    [crewSlice.reducerPath]: crewSlice.reducer,
    [categorySlice.reducerPath]: categorySlice.reducer,
    [emailSlice.reducerPath]: emailSlice.reducer,
    [ambassadorSlice.reducerPath]: ambassadorSlice.reducer,
    [lossesSlice.reducerPath]: lossesSlice.reducer,
    [promoVideoSlice.reducerPath]: promoVideoSlice.reducer,
    [detailsSlice.reducerPath]: detailsSlice.reducer,
    isAuth: persistedIsAuthReducer,
    language: persistedLangReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] // Ignore these redux-persist actions
      }
    })
      .concat(crewSlice.middleware)
      .concat(categorySlice.middleware)
      .concat(emailSlice.middleware)
      .concat(ambassadorSlice.middleware)
      .concat(lossesSlice.middleware)
      .concat(promoVideoSlice.middleware)
      .concat(detailsSlice.middleware)
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
